// ============================================================================
// VideoAttachment — видео-вложение чата: плеер монтируется ЛЕНИВО (§2.4) —
// только когда вложение близко к вьюпорту (или пользователь нажал play на
// заглушке). До монтирования — лёгкий плейсхолдер (ничего не загружается:
// ни файл, ни кадры). Вынесено из MessageBubble (SRP/бюджет; ср. chatAudioAttachment).
// ============================================================================

import { useState } from 'react';
import { MediaPlayer } from '@/components/media/MediaPlayer';
import { MediaPlaceholder } from '@/components/media/MediaPlaceholder';
import { useNearViewport } from '@/hooks/useNearViewport';

export function VideoAttachment({ id, name, mine }: {
  id: string;
  name: string;
  mine: boolean;
}) {
  // Клик по заглушке — «воспроизвести»: монтирует плеер и просит автозапуск.
  const [playRequested, setPlayRequested] = useState(false);
  const { ref, near } = useNearViewport();
  const active = near || playRequested;
  return (
    <div ref={ref}>
      {active ? (
        <MediaPlayer fileId={id} kind="video" name={name} mine={mine} compact autoPlay={playRequested} />
      ) : (
        <MediaPlaceholder kind="video" name={name} mine={mine} onPlay={() => setPlayRequested(true)} />
      )}
    </div>
  );
}
